import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { cachingApi } from "@faire/web--source/common/cachingApi";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import fetchSearchCatNavBanners from "@faire/web-api--source/api/v2/products/search/banners/post";
import { ISearchCatNavBannersResponse } from "@faire/web-api--source/indigofair/data/ISearchCatNavBannersResponse";
/**
 * @deprecated prefer to use `useCachedBannerResponseStore` or `withStores` instead
 */ export var CachedBannerResponseStore = function CachedBannerResponseStore() {
    "use strict";
    _class_call_check(this, CachedBannerResponseStore);
    this.cachedRequest = isLoggedInRetailer() ? function() {
        return ISearchCatNavBannersResponse.build();
    } : cachingApi(fetchSearchCatNavBanners);
};
CachedBannerResponseStore.get = singletonGetter(CachedBannerResponseStore);
export var useCachedBannerResponseStore = createStoreHook(CachedBannerResponseStore);
